import { useNftx, useTransaction } from '@nftx/react';
import { Address } from 'nftx.js';

const useWithdrawLiquidity = () => {
  const {
    network,
    provider,
    signer,
    core: { withdrawLiquidity },
  } = useNftx();

  type Args = Omit<
    Parameters<typeof withdrawLiquidity>[0],
    'network' | 'provider' | 'signer'
  > & { userAddress: Address };

  return useTransaction((args: Args) => {
    return withdrawLiquidity({
      ...args,
      network,
      provider,
      signer,
    });
  });
};

export default useWithdrawLiquidity;
